module.exports = __webpack_public_path__ + "img/customer-slide-right.1fe94ca1.png";